import { render, staticRenderFns } from "./wrongQuestion.vue?vue&type=template&id=e926858c&scoped=true"
import script from "./wrongQuestion.vue?vue&type=script&lang=js"
export * from "./wrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./wrongQuestion.vue?vue&type=style&index=0&id=e926858c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e926858c",
  null
  
)

export default component.exports